import { Loader } from "@googlemaps/js-api-loader";

import "./index.css";

export function setupCompanyInformation() {
  const container = document.querySelector(".container-company-information");

  if (container == null) {
    return;
  }

  const mapElement = document.getElementById("company-information-map");

  if (mapElement == null) {
    return;
  }

  const headOffice = container.querySelector(
    '[data-marker="head-office"]'
  ) as HTMLElement;
  const branchOffices = container.querySelectorAll(
    '[data-marker="branch"]'
  ) as NodeListOf<HTMLElement>;

  const loader = new Loader({
    apiKey: import.meta.env.VITE_GOOGLE_MAP_KEY,
    version: "weekly",
  });

  const mapOptions = {
    center: {
      lat: headOffice?.dataset.lat ? parseFloat(headOffice.dataset.lat) : 0,
      lng: headOffice?.dataset.lng ? parseFloat(headOffice.dataset.lng) : 0,
    },
    zoom: 5,
  };

  loader.load().then(async () => {
    const { Map } = (await google.maps.importLibrary(
      "maps"
    )) as google.maps.MapsLibrary;
    const map = new Map(mapElement, mapOptions);

    const icon = {
      url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAyVBMVEUAAAAAi9EAic8AitAAis8Ais4Aic8Ais8Ah80AiM4Ais0AiM8Ais8AjdUAis8AjNIAi9EAic4Aic4Aic4AiM0AiM4Ai84AisQAic8Aic4AiNEAitAAis4Aic4Ai9EAitAAiM8Aic4AicwAis8Aic0Aic8Aic4Ais4AisoAis8Aic74ti0AjtYAjNMAitAAi9EAj9cAjdTytTBqnImipmUpkLQukbA5lKlhm49xnoWQpHGrqF/sszS1qlk0la9ClqR/oHuOo3K+rFMIFUm3AAAAKnRSTlMA8Hbn4ZiLY0ZAOyISB9D8+di2rE0oHAT0Lgz2yOzqvrmxpp+Ab102GMgRAaxGAAACfklEQVRYw5SU167CMBBETUJvEogmrgRICIScXZcQeuf/P+o+ILQ2YBvOY5IZe7KFeVhUZpP8X34yqyzY7/RK7VgACi4QRNwu9X6T14oxgORPJEBcrH0vb0QjJbmNVKOo8aW+Oya5ZTHufqWvxMA/A3GFhenkkLvAXCeor5L+o0M1VL08ch+Y99ez3wbuB9p95qEEPASUPPq6HUBo0KhBCztEnTmJlHUW31yzU3bdcOteKnLqhy00j7/ckwf3i3kJbA2Zg7I09HKXJk/SnTQcZJk5KBgJYJeY7MDIUHDVsEkJ9Ca1DNKNpgxNRyVrA0HXPCU2J0npBjXHFJEe12lik66RHBwzNaecsExeWRpv544uoE/U/s1gr8jA0QlFTZ9kbwYZ2eticBDU7c3gpoLjUMYv/wGWg2XE1VsVVmiUMdxI8pDYHGS4kVgBjEY4Wvrj2shXcO5TNGZhaxlsgZN5x7lPYmMc9fZI52+1MYyxe6NMgRNwPqSP/3c4W8+njPkWAqHFarnP9suVQM5964BoNJGbIIAGeHnWbDDvUgyhIuah9196HewgCANBAB1MQG3EVtEDEQ4QEmLTrPD/P+fBixCYLfruJJMtzU5r8ZzUfLOkgxYgBVU64QFcCa4IngkFFMZ6xhporoGuVqiOlgU4QteE9QANIvROVo+gR4x2tWS1iFI+ZDnAo0ScNCwHSKOLbiJLAZL4spsNS7cgw4zelVg34vajnxv32CCvxvn3VY4tDlamE7QHbFMEeo1190QmR3jHVt1kF3QgWOvk3ZK7fT26bqD4HPkE+Rw/GV5kgtwu0FKmy58j/Qd1xokXZ/C7bKC3WHe6DJcT/mHOBtQb44Qg/HXsny4AAAAASUVORK5CYII=", // url
      scaledSize: new google.maps.Size(32, 32),
    };

    const marker = new google.maps.Marker({
      position: mapOptions.center,
      map,
      icon,
    });
    const infowindow = new google.maps.InfoWindow();

    // add head office info window
    const openHeadOfficeInfoWindow = () => {
      infowindow.close();
      infowindow.setContent(`<div class="container-company-information-heading" data-icon="home">
        <span>${
          headOffice?.querySelector(
            ".container-company-information-heading span"
          )?.innerHTML || ""
        }</span>
      </div>
      <p class="p-small">${
        headOffice?.querySelector(".container-company-information-address")
          ?.innerHTML || ""
      }</p>
      ${
        headOffice?.querySelector(".container-company-information-button")
          ?.outerHTML || ""
      }`);
      infowindow.open({
        anchor: marker,
        map,
      });
    };

    openHeadOfficeInfoWindow();

    marker.addListener("click", () => {
      openHeadOfficeInfoWindow();
    });

    // add branch offices markers and info windows
    branchOffices.forEach((branchOffice) => {
      const marker = new google.maps.Marker({
        position: {
          lat: branchOffice?.dataset.lat
            ? parseFloat(branchOffice.dataset.lat)
            : 0,
          lng: branchOffice?.dataset.lng
            ? parseFloat(branchOffice.dataset.lng)
            : 0,
        },
        map,
        icon,
      });

      google.maps.event.addListener(marker, "click", () => {
        infowindow.close();
        infowindow.setContent(`<div class="container-company-information-heading" data-icon="home">
          <span>${
            branchOffice?.querySelector(
              ".container-company-information-block-title"
            )?.innerHTML || ""
          }</span>
        </div>
        <p class="p-small">${
          branchOffice?.querySelector(".container-company-information-address")
            ?.innerHTML || ""
        }</p>
        ${
          branchOffice?.querySelector(".container-company-information-button")
            ?.outerHTML || ""
        }`);
        infowindow.open({
          anchor: marker,
          map,
        });
      });
    });
  });
}
